import React from 'react';
import './RGU.css';
import FMSimage from '../Assets/remote1.jpg'; // First image (full size)
import FMSimage2 from '../Assets/remote2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/remote3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/remote4.webp'; // Image for Why Choose section
import FMSimage5 from '../Assets/remote5.webp'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">REMOTE GATEWAY UNIT</h1>
                    <p className="FMS-description">
                    The Remote Gateway Unit (RGU) from Vajra IoT is a powerful solution designed to provide seamless connectivity and communication across distributed systems. It integrates various devices, sensors, and networks into a unified framework, enabling efficient remote monitoring, control, and data collection. The RGU ensures secure data transmission, real-time insights, and reliable performance across multiple industries. It acts as the backbone of IoT systems, providing a critical link between devices and centralized management platforms.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Fuel Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Seamless Connectivity:</strong> Ensures uninterrupted communication between devices and the central system, even in remote locations.</li>
                        <li><strong>Secure Data Transmission:</strong> Employs advanced encryption and authentication protocols to safeguard data integrity and prevent unauthorized access.</li>
                        <li><strong>Real-Time Monitoring:</strong> Allows real-time data collection and monitoring of all connected devices, ensuring proactive management and decision-making.</li>
                        <li><strong>Flexible Integration:</strong> Easily integrates with a variety of sensors, devices, and networks, offering scalability to suit diverse business needs.</li>
                        <li><strong>Remote Control:</strong> Enables remote operation of devices and equipment, reducing the need for on-site interventions and increasing operational efficiency.</li>
                    </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Centralized Data Hub:</strong> All connected devices send their data to a central system where it is analyzed and processed for insights.</li>
                        <li><strong>Real-Time Alerts:</strong> The system sends immediate notifications in case of any irregularities, allowing swift intervention and troubleshooting.</li>
                        <li><strong>Automated Control Systems:</strong> The RGU enables automation by adjusting settings and operations based on predefined parameters, optimizing performance.</li>
                        <li><strong>Data Visualization:</strong> Offers intuitive dashboards to visualize system performance, device status, and critical metrics for informed decision-making.</li>
                        <li><strong>Scalable and Robust:</strong> Designed to handle a growing number of devices and sensors, ensuring long-term scalability without compromising performance.</li>
                    </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Remote Gateway Unit</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
                        <li><strong>Reliable Connectivity:</strong> Our RGU ensures continuous, stable communication across various networks and environments.</li>
                        <li><strong>Enhanced Security:</strong> With built-in security measures, the RGU guarantees safe data transmission and protection against potential cyber threats.</li>
                        <li><strong>Cost-Effective:</strong> By reducing the need for manual interventions and increasing operational efficiency, the RGU helps lower overall system maintenance costs.</li>
                        <li><strong>Flexible and Customizable:</strong> The RGU is adaptable to various industry requirements, making it suitable for businesses of all sizes.</li>
                    </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our FMS */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using FMS" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    The Remote Gateway Unit is a versatile solution used across various industries to streamline operations, improve connectivity, and enable real-time data analysis. These industries trust our RGU for its reliability and performance:
                    <ul>
                        <li>Manufacturing</li>
                        <li>Energy & Utilities</li>
                        <li>Logistics & Transportation</li>
                        <li>Smart Cities</li>
                        <li>Healthcare (upcoming)</li>
                    </ul>
                    </p>
                </div>
            </div>

        </div>
    );
};

export default FMS;
